import useHttpClient from "./http/useHttpClient";
import {OrderModel, OrderProductModel, OrderTaxeModel} from "../Models/OrderModel";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../Models/StateModel";
import {UserModel} from "../Models/UserModel";
import axios from "axios";
import {setUser} from "../store/actions";
import {HistoriqueOrderRequestModel} from "../Models/request/HistoriqueOrderRequestModel";
import {OrderResponseModel} from "../Models/OrderResponseModel";
import {RefundedOrderRequestModel} from "../Models/request/RefundedOrderRequestModel";

function getOrderTaxes(orderProducts: OrderProductModel[] | undefined): OrderTaxeModel[] {
    if(!orderProducts) {
        return [];
    }
    const result: OrderTaxeModel[] = []
    orderProducts.forEach(product => {
        const index = result.findIndex(t => t.tvaCode === product.tvaCode)
        if(index !== -1) {
            result[index].totalPriceTTC = (result[index].totalPriceTTC ?? 0) + (product.totalPriceTTC ?? 0)
            result[index].totalPriceHT = (result[index].totalPriceHT ?? 0) + (product.totalPriceHT ?? 0)
        } else {
            result.push({
                tvaCode: product.tvaCode,
                totalPriceHT: product.totalPriceHT,
                totalPriceTTC: product.totalPriceTTC,
                tvaRate: product.tvaRate
            })
        }
    })
    return result.map(r => {
        const total = (r.totalPriceTTC ?? 0) - (r.totalPriceHT ?? 0)
        const taxe: OrderTaxeModel = {...r, totalTva: Math.round(total * 100) / 100}
        return taxe
    })
}

export const usePostOrder = (onFirst: () => void, onLast: () => void): (onSuccess: (res: any) => void, onError: (err: any) => void) => void => {
    const dispatch = useDispatch()
    const {postOrder} = useHttpClient()
    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const user = useSelector<StateModel, UserModel | undefined>(state => state.user)
    return (onSuccess: (res: any) => void, onError: (err: any) => void) => {
        onFirst()
        const date = new Date()
        const orderToPost: OrderModel | undefined = {
            ...panier,
            createdAt: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds())),
            orderProducts: panier?.orderProducts?.map(p => {
                const product: OrderProductModel = {...p, discountModel: undefined, unitDepositPriceTTC: undefined, totalDepositPriceTTC: undefined, product: {id: p.product.id}}
                return product
            }) || [],
            nbOrderProducts: panier?.orderProducts?.length || 0,
            orderOperation: 'vente',
            orderTaxes: getOrderTaxes(panier?.orderProducts)
        }
        postOrder(orderToPost)
            .then((res: OrderResponseModel) => {
                if(user?.id) {
                    const body: HistoriqueOrderRequestModel = {
                        userId: user.id,
                        reference: res.reference || '',
                        image: res.orderProducts ? res.orderProducts[0].product.image || '' : '',
                        priceTTC: res.priceTTC ? +res.priceTTC : 0,
                        pdvName: res.pdv?.name || '',
                    }
                    axios.post(`${process.env.REACT_APP_BART_URL}/orders/create`, body)
                        .then((response) => {
                            const orders = user.orders ? [...user.orders] : []
                            orders.push(response.data)
                            dispatch(setUser({...user, orders}))
                        })
                        .finally(() => {
                            onSuccess(res)
                        })
                } else {
                    onSuccess(res)
                }
            })
            .catch(err => {
                const body: RefundedOrderRequestModel = {
                    date: new Date(),
                    reference: orderToPost.reference ?? '',
                    data: orderToPost,
                    reason: JSON.stringify(err)
                }
                void axios.post(`${process.env.REACT_APP_BART_URL}/refunded-order`, body)
                onError(err)
            })
            .finally(onLast)
    }

}
